// do not really understand what I'm trying to accomplish here but it's a fake tabs control so I'm not going to think about it too hard.
var tabButton = item => `<li><a href="#tabbody-${item.id}">${item.text}</a></li>`;

var tabBody = item => {
    return `<div class="tabbody" id="tabbody-${item.id}"><p class="tabbody-header" id="tabregion-${item.id}">${item.body}</p></div>`;
}

var t = (data) => {
    return `<ul class="tabbody-commands">${data.items.map(tabButton).join("") }</ul>${data.items.map(tabBody).join("") }`;
}

export = t; 